import { PaymentType } from './payment-type.js';

export enum PaymentMethod {
  OnlineBankCard = 'OnlineBankCard',
  Cash = 'Cash',
  POS = 'POS',
  BankTransfer = 'BankTransfer',
}

export function getDefaultPaymentMethodForPaymentType(paymentType: PaymentType): PaymentMethod {
  switch(paymentType) {
    case PaymentType.OnDelivery:
      return PaymentMethod.Cash;
    case PaymentType.Online:
      return PaymentMethod.OnlineBankCard;
  }
}
